<template>
  <b-modal
    id="schedrejectedmodal"
    size="lg"
    centered
    hide-footer
    hide-header
    no-close-on-backdrop
    class="p-0"
    @hidden="closeScheduleInterviewModal();
        context.$bvModal.hide('schedrejectedmodal');
        rejectedroundselected = {};
        recruiterRemarks = '';
        changeModalScreen(false, false, false);"
  >
    <div class="modalheading d-flex align-items-center justify-content-between">
      <span class="caution-txt">Interview round details</span>
    </div>

    <div
      class="xMarkCancel"
      @click="
        closeScheduleInterviewModal();
        context.$bvModal.hide('schedrejectedmodal');
        rejectedroundselected = {};
        recruiterRemarks = '';
        changeModalScreen(false, false, false);
      "
    >
      <img src="../../../assets/cross-round.svg" alt="" />
    </div>
    <hr />
    <b-overlay :show="showSpinner" rounded="sm">
      <div class="rejschedmodalheight" v-if="rejectschedulemodal">
        <div>
          <div
            class="rejectedsched-headtext mt-3"
            v-if="activeCandidate.roundstatuslevel != null"
          >
            {{ activeCandidate.roundstatusname }} in round
            <strong
              v-if="
                activeCandidate.roundstatuslevel < '10' &&
                activeCandidate.roundstatuslevel != '0'
              "
              >0{{ activeCandidate.roundstatuslevel }}</strong
            >
            <strong v-else>{{ activeCandidate.roundstatuslevel }}</strong>
          </div>

          <div class="mt-1 rejectedsched-headtext">
            <span class="asterik">*</span> Please Select a Round
          </div>
        </div>
        <div class="iproundsrejected">
          <div v-for="i in interviewProcess.process" :key="i.id">
            <div
              class="pointer"
              v-if="
                i.id != 0 &&
                i.id != 'F' &&
                i.id != 'H' &&
                i.id != 'R' &&
                i.id != 'NI'
              "
              :class="
                i.id == rejectedroundselected.id
                  ? 'rejectedsched-roundbox-bluebox'
                  : 'rejectedsched-roundbox'
              "
              :style="i.id == 1 ? '' : 'margin-top: 10px'"
              @click="selectrejectedround(i)"
            >
              <div
                style="width: 100%"
                class="d-flex align-items-center justify-content-between"
              >
                <div
                  style="width: 70%"
                  class="jdd-rejectedsched-roundname-text text-truncate"
                >
                  {{ i.name }}
                </div>
                <div class="jdd-rejectedsched-roundtype-text">
                  {{ i.type === "f2f" ? "Face to face" : "Assessment" }}
                </div>
              </div>
            </div>
          </div>
          <div
            class="d-flex align-items-center justify-content-end rejschedbtns"
          >
            <b-button
              class="addbtn"
              :class="
                Object.keys(rejectedroundselected).length == 0
                  ? 'global-disabledField'
                  : ''
              "
              @click="changeModalScreen(false, true, null)"
              :disabled="Object.keys(rejectedroundselected).length == 0"
              >Select</b-button
            >
            <b-button
              class="jdcancelbtn ml-3"
              @click="
                context.$bvModal.hide('schedrejectedmodal'),
                  (rejectedroundselected = {}),
                  (recruiterRemarks = '')
              "
              >Cancel</b-button
            >
          </div>
        </div>
      </div>

      <div v-if="confirmmodal" class="rejschedmodalheight">
        <div class="modalheading d-flex align-items-center">
          <img
            @click="
              changeModalScreen(true, false, false), (recruiterRemarks = '')
            "
            src="../../../assets/bckarrow.svg"
            alt=""
            class="pointer"
          />
          <span class="caution-txt ml-2">Confirm Message</span>
        </div>

        <div class="rejectedsched-headtext mt-3">
          Are you sure this candidate should be moved to
          <strong>{{ rejectedroundselected.name }}</strong>
        </div>
        <div class="topDiv mt-4">
          <label class="fill-feedbck-fieldsetStyle"
            >Remarks&nbsp;<span class="asterik">*</span></label
          >
          <b-form-textarea
            class="remarksField"
            id="input-1"
            type="text"
            rows="3"
            max-rows="6"
            no-resize
            autofocus
            placeholder="Enter Remarks"
            v-model.trim="recruiterRemarks"
            v-on:keyup.enter="rejectedscheduleInterviewModal()"
          >
          </b-form-textarea>
        </div>
        <div>
          <div
            class="d-flex align-items-center justify-content-end rejschedbtns"
          >
            <b-button
              class="addbtn"
              @click="rejectedscheduleInterviewModal"
              :disabled="recruiterRemarks == ''"
              >Select</b-button
            >
          </div>
        </div>
      </div>

      <div v-if="rejectscheduleinterview" class="position-relative">
        <div class="modalheading d-flex align-items-center">
          <img
            @click="changeModalScreen(false, true, false)"
            src="../../../assets/bckarrow.svg"
            alt=""
            class="pointer"
          />

          <span class="caution-txt ml-2">{{
            ScheduleInterview.schedulename
          }}</span>
        </div>
        <div class="candidates-view-modal mt-3">
          <b-row class="Schedule-view-details">
            <b-col cols="6">
              <div class="topDiv mt-3">
                <label class="fieldsetStyle"
                  >Select Date&nbsp;<span class="asterik">*</span></label
                >
                <b-form-datepicker
                  v-model="context.$v.ScheduleInterview.date.$model"
                  :class="{
                    error: context.$v.ScheduleInterview.date.$error,
                  }"
                  :min="dateDisabled"
                  locale="en"
                  placeholder="Select date"
                ></b-form-datepicker>
                <div
                  class="validationicon"
                  v-if="
                    context.$v.ScheduleInterview.date.$dirty &&
                    !context.$v.ScheduleInterview.date.required
                  "
                  v-b-popover.hover.top.v-danger="{
                    content: 'Required',
                  }"
                >
                  <img src="../../../assets/deletepopupicon.svg" alt="" />
                </div>
              </div>
            </b-col>
            <b-col cols="3">
              <div class="topDiv mt-3">
                <label class="fieldsetStyle"
                  >Start Time&nbsp;<span class="asterik">*</span></label
                >
                <vue-timepicker
                  class="SI-starttime"
                  close-on-complete
                  :minute-interval="15"
                  :hour-range="enabledStartTimeHours"
                  :minute-range="enableStartTimedMinutes"
                  @change="endtime()"
                  v-model="context.$v.ScheduleInterview.startTime.$model"
                  :class="{
                    error:
                      context.$v.ScheduleInterview.startTime.$error ||
                      ScheduleInterview.isStartDateValid == true,
                  }"
                  placeholder="Start time"
                ></vue-timepicker>
                <div
                  class="validationicon"
                  v-if="
                    context.$v.ScheduleInterview.startTime.$dirty &&
                    !context.$v.ScheduleInterview.startTime.required
                  "
                  v-b-popover.hover.top.v-danger="{
                    content: 'Required, please select both minutes and hours',
                  }"
                >
                  <img src="../../../assets/deletepopupicon.svg" alt="" />
                </div>
                <div
                  class="validationicon mr-2"
                  v-if="ScheduleInterview.isStartDateValid == true"
                  v-b-popover.hover.top.v-danger="{
                    content: 'Invalid Time Selection',
                  }"
                >
                  <img src="../../../assets/deletepopupicon.svg" alt="" />
                </div>
              </div>
            </b-col>
            <b-col cols="3">
              <div class="topDiv mt-3">
                <label class="fieldsetStyle"
                  >End Time&nbsp;<span class="asterik">*</span></label
                >
                <vue-timepicker
                  close-on-complete
                  class="SI-endtime"
                  :minute-interval="15"
                  :hour-range="enabledEndTimeHours"
                  :minute-range="enabledEndTimeMinutes"
                  v-model="ScheduleInterview.endTime"
                  placeholder="End time"
                  :class="{
                    error: context.$v.ScheduleInterview.endTime.$error,
                  }"
                ></vue-timepicker>
                <div
                  class="validationicon"
                  v-if="
                    context.$v.ScheduleInterview.endTime.$dirty &&
                    !context.$v.ScheduleInterview.endTime.required
                  "
                  v-b-popover.hover.top.v-danger="{
                    content: 'Required, please select both minutes and hours',
                  }"
                >
                  <img src="../../../assets/deletepopupicon.svg" alt="" />
                </div>
              </div>
            </b-col>
          </b-row>
          <hr />
          <b-row class="align-items-center">
            <b-col cols="6">
              <div class="externalpanel topDiv">
                <label
                  :class="
                    !isPanelEmpty || isDateTimeEmpty
                      ? 'disabledfieldsetStyle'
                      : 'fieldsetStyle'
                  "
                  >External Panelist</label
                >
                <b-form-tags
                  input-id="tags-basic"
                  class="inputField"
                  invalid-tag-text="Invalid Email"
                  :tag-validator="tagValidator"
                  :class="{
                    extdisinputField:
                      isDateTimeEmpty ||
                      !isPanelEmpty ||
                      Object.keys(ScheduleInterview.panelist).length != 0,
                    inputField: isPanelEmpty || !isDateTimeEmpty,
                  }"
                  placeholder="Enter Email"
                  v-model="ScheduleInterview.externalPanelist"
                  remove-on-delete
                  style="max-height: 100px; overflow-y: auto"
                  :disabled="
                    !isPanelEmpty ||
                    isDateTimeEmpty ||
                    Object.keys(ScheduleInterview.panelist).length != 0
                  "
                ></b-form-tags>
              </div>
            </b-col>
            <b-col cols="2">
              <div class="d-flex align-items-center justify-content-center">
                <img
                  class="mr-2"
                  src="../../../assets/img/jddetails/panel-line.svg"
                  alt=""
                />
                <span class="jd-or-style">OR</span>
                <img
                  class="ml-2"
                  src="../../../assets/img/jddetails/panel-line.svg"
                  alt=""
                />
              </div>
            </b-col>

            <b-col cols="4">
              <div
                v-if="
                  isExternalEmpty &&
                  !isDateTimeEmpty &&
                  (context.requiredPanel ||
                    (!context.requiredPanel && userList.length > 0))
                "
                class="
                  jdpanel
                  d-flex
                  align-items-center
                  justify-content-between
                  pointer
                "
                @click="
                  panelistSel(ScheduleInterview.panelist),
                    openFolderModal('selectpanel'),
                    context.$refs.selectedpanel.getSelctedPanelist()
                "
              >
                <img
                  class="ml-3 pointer"
                  src="../../../assets/img/jddetails/select-panel.svg"
                  alt=""
                />
                <span class="internal-panelist-text mr-5"
                  >Internal Panelist</span
                >
              </div>
              <div
                v-else
                class="
                  jdpanel-disable
                  d-flex
                  align-items-center
                  justify-content-between
                "
              >
                <img
                  class="ml-3 pointer"
                  src="../../../assets/img/jddetails/select-panel-disable.svg"
                  alt=""
                />
                <span class="internal-panelist-text-disable mr-5"
                  >Internal Panelist</span
                >
              </div>
            </b-col>
          </b-row>

          <b-row
            class="jd-panel-selection ml-0 mr-0 mt-3"
            v-if="ScheduleInterview.panelist.name"
          >
            <span class="p-3 internal-selected-text">
              Internal Panelist
              <div class="">
                <div v-if="ScheduleInterview.teamsStatus != '5'" class="">
                  <div
                    class="
                      d-flex
                      align-items-center
                      justify-content-between
                      jd-panel-selection-card
                    "
                  >
                    <div class="panel-name">
                      {{ ScheduleInterview.panelist.name }}
                    </div>

                    <div>
                      <span
                        v-if="ScheduleInterview.teamsStatus == '0'"
                        class="status-text"
                        style="color: #038e00"
                      >
                        <span class="availability-class"> Availability :</span
                        >{{ ScheduleInterview.panelistStatus }}</span
                      >

                      <span
                        v-else-if="ScheduleInterview.teamsStatus == '1'"
                        class="status-text"
                        style="color: #bdbd01"
                      >
                        <span class="availability-class"> Availability :</span
                        >{{ ScheduleInterview.panelistStatus }}</span
                      >
                      <span v-else class="status-text" style="color: red">
                        <span class="availability-class"> Availability :</span
                        >{{ ScheduleInterview.panelistStatus }}</span
                      >
                    </div>
                    <div class="pointer" @click="removePanelist">
                      <img
                        src="../../../assets/img/jddetails/removePanlist.svg"
                        alt=""
                      />
                    </div>
                  </div>
                </div>

                <div v-else-if="ScheduleInterview.teamsStatus == '5'" class="">
                  <div
                    class="
                      d-flex
                      align-items-center
                      justify-content-between
                      jd-panel-selection-card
                    "
                  >
                    <div class="panel-name">
                      {{ ScheduleInterview.panelist.name }}
                    </div>
                    <span class="status-text" style="color: red">
                      <span class="availability-class"> Availability :</span>
                      {{ ScheduleInterview.panelistStatus }}
                    </span>
                    <div class="pointer" @click="removePanelist">
                      <img
                        src="../../../assets/img/jddetails/removePanlist.svg"
                        alt=""
                      />
                    </div>
                  </div>
                </div>
              </div>
            </span>
          </b-row>
          <div class="asterik" v-if="ScheduleInterview.errorpanel == true" mt-2>
            Please Select a Internal Panelist or Add an External Panelist
          </div>
          <hr />

          <b-row class="mt-3">
            <b-col cols="3">
              <div class="sm-small-txt mb-1">Schedule With</div>
              <div class="position-relative">
                <div
                  class="sm-meeting pointer"
                  ref="schedule-card"
                  :style="
                    ScheduleInterview.date == '' ||
                    ScheduleInterview.startTime == '' ||
                    (isPanelEmpty && isExternalEmpty)
                      ? 'background-color :#dbdbe2;cursor: default'
                      : ''
                  "
                  @click="openScheduleCard = !openScheduleCard"
                  v-closable="{
                    exclude: ['schedule-card'],
                    handler: 'closeScheduleCard',
                  }"
                >
                  <div class="d-flex align-items-center">
                    <div>{{ ScheduleInterview.selectedOption }}</div>
                    <div>
                      <img
                        v-if="
                          ScheduleInterview.selectedOption == 'Microsoft Teams'
                        "
                        class="ml-3"
                        src="../../../assets/img/jddetails/teams.svg"
                        alt=""
                      />
                      <img
                        v-else-if="ScheduleInterview.selectedOption == 'VCCL'"
                        class="ml-3"
                        src="../../../assets/img/jddetails/vccl.svg"
                        alt=""
                      />
                    </div>
                  </div>
                  <div>
                    <img
                      v-if="
                        ScheduleInterview.date != '' &&
                        ScheduleInterview.startTime != '' &&
                        (!isPanelEmpty || !isExternalEmpty) &&
                        openScheduleCard == true
                      "
                      src="../../../assets/img/jddetails/greyUpDirect.svg"
                      alt=""
                    />
                    <img
                      v-else
                      src="../../../assets/img/jddetails/greyDownDirect.svg"
                      alt=""
                    />
                  </div>
                </div>
                <div
                  class="sm-meeting-select"
                  v-if="
                    ScheduleInterview.date != '' &&
                    ScheduleInterview.startTime != '' &&
                    (!isPanelEmpty || !isExternalEmpty) &&
                    openScheduleCard == true
                  "
                >
                  <div
                    @click="
                      !checkingDomain
                        ? ((ScheduleInterview.selectedOption =
                            'Microsoft Teams'),
                          (ScheduleInterview.withTeams = true),
                          (ScheduleInterview.withVccl = false),
                          (openScheduleCard = false),
                          assignLink('Microsoft Teams'))
                        : ''
                    "
                    :style="checkingDomain ? 'cursor:not-allowed' : ''"
                    :class="
                      ScheduleInterview.selectedOption == 'Microsoft Teams'
                        ? 'sm-sel-option p-2 m-1'
                        : 'sm-option p-2 m-1 pointer'
                    "
                  >
                    <span
                      :class="checkingDomain ? 'disable-round-add-text ' : ''"
                      >Microsoft Teams</span
                    >
                    <img
                      :style="checkingDomain ? 'opacity:50%' : ''"
                      class="mr-3"
                      src="../../../assets/img/jddetails/teams.svg"
                      alt=""
                    />
                  </div>
                  <div
                    @click="
                      (ScheduleInterview.selectedOption = 'VCCL'),
                        (ScheduleInterview.withTeams = false),
                        (ScheduleInterview.withVccl = true),
                        (openScheduleCard = false)
                    "
                    :class="
                      ScheduleInterview.selectedOption == 'VCCL'
                        ? 'sm-sel-option p-2 m-1'
                        : 'sm-option p-2 m-1 pointer'
                    "
                  >
                    <span>VCCL</span>
                    <img
                      class="mr-3"
                      src="../../../assets/img/jddetails/vccl.svg"
                      alt=""
                    />
                  </div>

                  <div
                    @click="
                      (ScheduleInterview.selectedOption = 'None'),
                        (ScheduleInterview.withTeams = false),
                        (ScheduleInterview.withVccl = false),
                        (openScheduleCard = false),
                        removeLink()
                    "
                    :class="
                      ScheduleInterview.selectedOption == 'None'
                        ? ' defaultCursor sm-sel-option p-2 m-1'
                        : 'sm-option p-2 m-1 pointer'
                    "
                  >
                    <span>None</span>
                  </div>
                </div>
              </div>
            </b-col>
            <b-col class="mt-3" cols="8">
              <div class="sm-meetingLink">
                <label style="left: 1.5vw" class="fieldsetStyle"
                  >Meeting Link &nbsp;<span class="asterik">*</span></label
                >
                <div class="position-relative">
                  <b-form-input
                    class="sm-inputField"
                    id="textarea"
                    type="text"
                    v-model.trim="
                      context.$v.ScheduleInterview.meetingLink.$model
                    "
                    :class="{
                      error: context.$v.ScheduleInterview.meetingLink.$error,
                    }"
                    :disabled="
                      context.ScheduleInterview.withTeams == true ||
                      context.ScheduleInterview.withVccl == true
                    "
                    :placeholder="
                      context.ScheduleInterview.withTeams == true ||
                      context.ScheduleInterview.withVccl == true
                        ? 'Meeting Link'
                        : 'Enter Meeting Link'
                    "
                  >
                  </b-form-input>
                </div>

                <div
                  class="jdDetails-validationicon"
                  v-if="
                    context.$v.ScheduleInterview.meetingLink.$dirty &&
                    !context.$v.ScheduleInterview.meetingLink.required
                  "
                  v-b-popover.hover.top.v-danger="{
                    content: 'Required',
                  }"
                >
                  <img src="../../../assets/deletepopupicon.svg" alt="" />
                </div>
              </div>
            </b-col>
            <b-col cols="1" class="mt-3">
              <p v-if="context.ScheduleInterview.meetingLink == ''">
                <img
                  class="mt-1"
                  src="../../../assets/img/jddetails/sharecopydisable.svg"
                  alt=""
                />
              </p>
              <p v-else @click="copyToClipboard">
                <img
                  v-b-tooltip.hover
                  :title="context.ScheduleInterview.toolTipTitle"
                  class="pointer mt-1"
                  src="../../../assets/img/jddetails/sharecopy.svg"
                  alt=""
                />
              </p>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="12">
              <div class="topDiv mt-4">
                <label class="fieldsetStyle">Meeting Summary&nbsp;</label>
                <b-form-textarea
                  rows="3"
                  max-rows="4"
                  class="inputField"
                  type="text"
                  placeholder="Enter meeting summary"
                  v-model.trim="ScheduleInterview.meetingSummary"
                >
                </b-form-textarea>
              </div>
              <div
                class="sched-validationicon"
                v-if="!context.$v.ScheduleInterview.meetingSummary.maxLength"
                v-b-popover.hover.top.v-danger="{
                  content: 'Should not exceed 1024 characters',
                }"
                variant="primary"
              >
                <img src="../../../assets/deletepopupicon.svg" alt="" />
              </div>
            </b-col>
          </b-row>
        </div>

        <div class="d-flex align-items-center justify-content-end mt-3">
          <b-button @click="scheduled()" class="addbtn pr-4 pl-4">
            {{ ScheduleInterview.scheduleButton }}</b-button
          >
        </div>
      </div>
      <div v-if="rejectsendassessment">
        <div class="jd-modalheight">
          <div class="jd-modal-sub-head mb-2">Configure</div>
          <div style="word-break: break-all" class="jd-configure-box p-3 m-1">
            <div>
              <div class="d-flex justify-content-between align-items-center">
                <div>
                  Configuration Name : <b>{{ configName }}</b>
                </div>
                <div
                  class="pointer"
                  v-if="disableShare == false"
                  @click="configView"
                >
                  <img src="../../../assets/configicon.svg" alt="" />
                </div>
                <div class="pointer" v-else>
                  <img src="../../../assets/configdisable.svg" alt="" />
                </div>
              </div>
            </div>

            <div
              class="config-warn mt-2 p-2 config-warn-text"
              v-if="disableShare == true"
            >
              <img src="../../../assets/configwarn.svg" alt="" />

              The configuration has expired, you cannot share the assessment.
            </div>
          </div>
          <hr />
          <div class="jd-modal-sub-head mb-2">Tests</div>
          <div
            class="d-flex align-items-center mb-2 mr-2"
            v-for="(test, testindex) in rejectedroundselected.selectedtests"
            :key="testindex"
          >
            <div class="testconfig-card-container w-100">
              <div
                style="width: 100%"
                class="d-flex justify-content-between align-items-center"
              >
                <div style="width: 50%">
                  <div class="jd-card-sub-head">Topic Name</div>
                  <div class="folder-bar-head text-truncate mt-1">
                    {{ test.topicName }}
                  </div>
                </div>
                <div style="width: 50%">
                  <div class="jd-card-sub-head">Test Name</div>
                  <div class="folder-bar-head text-truncate mt-1">
                    {{ test.name }}
                  </div>
                </div>
              </div>
              <hr />
              <div
                class="d-flex align-items-center justify-content-between mt-3"
              >
                <div class="d-flex align-items-center flex-column">
                  <div class="testconfig-card-subheads">Difficulty Level</div>
                  <div
                    class="testconfig-card-subheadcontent"
                    style="color: #038e00"
                  >
                    {{ test.difficultyLevel }}
                  </div>
                </div>
                <div class="d-flex align-items-center flex-column">
                  <div
                    class="testconfig-card-subheads"
                    v-if="test.numberOfSections <= 1"
                  >
                    No.of Section
                  </div>
                  <div class="testconfig-card-subheads" v-else>
                    No.of Sections
                  </div>
                  <div
                    class="testconfig-card-subheadcontent"
                    style="color: #5782ff"
                  >
                    {{ test.numberOfSections }}
                  </div>
                </div>
                <div class="d-flex align-items-center flex-column">
                  <div class="testconfig-card-subheads">No.of Questions</div>
                  <div
                    class="testconfig-card-subheadcontent"
                    style="color: #ffc145"
                  >
                    {{ test.noOfQuestions }}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="d-flex justify-content-end align-items-center mr-2">
            <b-button
              class="addbtn pr-4 pl-4 pointer"
              :disabled="disableShare == true"
              @click="shareTestRej(), (recruiterRemarks = '')"
            >
              Send
            </b-button>
          </div>
        </div>
      </div>
    </b-overlay>
  </b-modal>
</template>
<script>
import VueTimepicker from "vue2-timepicker";
import "vue2-timepicker/dist/VueTimepicker.css";
import { mapGetters } from "vuex";

import {
  selectrejectedround,
  openFolderModal,
  removePanelist,
  closeShareModal,
  endtime,
  copyToClipboard,
  changeToolTipTitle,
} from "../helpers";
import {
  rejectedscheduleInterviewModal,
  shareTestRej,
  getTeamToken,
  scheduled,
  createmeetingwithVccl,
} from "../asynchronous";

export default {
  name: "RejectCandModal",
  components: {
    VueTimepicker,
  },
  props: {
    activeCandidate: Object,
    panelistSel: Function,
    configView: Function,
    externalPanFunc: Function,
    interviewProcess: Object,
    ScheduleInterview: Object,
    configName: String,
    userList: Array,
    context: Object,
    changeModalScreen: Function,
    rejectschedulemodal: Boolean,
    confirmmodal: Boolean,
    rejectsendassessment: Boolean,
    rejectscheduleinterview: Boolean,
    requiredPanel: Boolean,
  },
  data() {
    return {
      externalPan: [],
      rejectedroundselected: {},
      showSpinner: false,
      recruiterRemarks: "",
      openScheduleCard: false,
    };
  },
  computed: {
    ...mapGetters("userVUEX", {
      User: "getRoleValues",
    }),
    checkingDomain() {
      const emailDomain = this.User.email.split("@")[1];

      const isNotSimplify3x = emailDomain !== "simplify3x.com";

      return isNotSimplify3x;
    },
    disableShare() {
      let share = false;
      const closeTestDateString = this.rejectedroundselected.closeTestdt;

      const closeTestDate = new Date(closeTestDateString);
      const currentDate = new Date();

      const options = {
        year: "numeric",
        month: "numeric",
        day: "numeric",
        hour: "numeric",
        minute: "numeric",
        second: "numeric",
        hour12: true,
      };

      const formattedCloseTestDate = closeTestDate.toLocaleString(
        "en-US",
        options
      );
      const formattedCurrentDate = currentDate.toLocaleString("en-US", options);

      if (new Date(formattedCloseTestDate) <= new Date(formattedCurrentDate)) {
        share = true;
      } else {
        share = false;
      }
      return share;
    },
    enabledStartTimeHours() {
      const currentDate = new Date();
      const currentHour = currentDate.getHours();
      const selectedDate = new Date(this.ScheduleInterview.date);
      if (
        currentDate.setHours(0, 0, 0, 0) === selectedDate.setHours(0, 0, 0, 0)
      ) {
        return [[currentHour, 23]];
      } else {
        return [[0, 23]];
      }
    },
    enableStartTimedMinutes() {
      const currentDate = new Date();
      const currentMinute = currentDate.getMinutes();
      const currentHour = currentDate.getHours();
      const selectedDate = new Date(this.ScheduleInterview.date);
      if (
        parseInt(this.ScheduleInterview.startTime.slice(0, 2)) ==
          parseInt(currentHour) &&
        currentDate.setHours(0, 0, 0, 0) === selectedDate.setHours(0, 0, 0, 0)
      ) {
        return [[currentMinute, 59]];
      } else {
        return [[0, 59]];
      }
    },
    enabledEndTimeHours() {
      const selectedStartHour = parseInt(
        this.ScheduleInterview.startTime.slice(0, 2)
      );
      return [[selectedStartHour, 23]];
    },
    enabledEndTimeMinutes() {
      const selectedStartMin = parseInt(
        this.ScheduleInterview.startTime.slice(3, 6)
      );
      if (
        parseInt(this.ScheduleInterview.endTime.slice(0, 2)) ==
        parseInt(this.ScheduleInterview.startTime.slice(0, 2))
      ) {
        return [[selectedStartMin + 1, 59]];
      } else {
        return [[0, 59]];
      }
    },
    dateDisabled() {
      const now = new Date();
      const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
      let dd = String(today.getDate()).padStart(2, "0");
      let minDate = new Date(today);
      minDate.setMonth(minDate.getMonth());
      minDate.setDate(dd);
      return minDate;
    },
    isDateTimeEmpty() {
      return (
        this.ScheduleInterview.date == "" ||
        this.ScheduleInterview.startTime == "" ||
        this.ScheduleInterview.endTime == ""
      );
    },
    checkEmailType() {
      let newOption = this.context.roleValues.email.split("@");
      return newOption[1] === "simplify3x.com";
    },
    isExternalEmpty() {
      return this.ScheduleInterview.externalPanelist.length == 0;
    },
    checkColumn() {
      let newOption = this.checkEmailType;
      let value = "";
      if (newOption) {
        value = "8";
      } else {
        value = "12";
      }
      return value;
    },
    teamsDisableValue() {
      let temp;
      if (
        this.ScheduleInterview.date != "" &&
        this.ScheduleInterview.startTime != "" &&
        this.ScheduleInterview.meetingLink == ""
      ) {
        if (this.isPanelEmpty && this.isExternalEmpty) {
          temp = true;
        } else if (!this.isPanelEmpty || !this.isExternalEmpty) {
          temp = false;
        }
      } else {
        temp = true;
      }
      return temp;
    },
    isPanelEmpty() {
      return Object.keys(this.ScheduleInterview.panelist).length == 0;
    },
  },
  watch: {
    externalPan(newVal) {
      this.externalPanFunc(newVal);
    },
  },
  methods: {
    selectrejectedround(i) {
      selectrejectedround(this, i);
    },
    async rejectedscheduleInterviewModal() {
      await rejectedscheduleInterviewModal(this.context, this);
    },
    openFolderModal(flag) {
      openFolderModal(this.context, flag);
    },
    // REMOVE A SELECTED PANELIST
    removePanelist() {
      removePanelist(this.context);
    },
    async shareTestRej() {
      await shareTestRej(this.context, this);
    },

    closeShareModal() {
      closeShareModal(this.context, this);
    },
    tagValidator(tag) {
      let regex = /^[\w-.]+@([\w-]+\.)+[\w-]{2,4}$/;
      return tag.match(regex) != null;
    },
    copyToClipboard() {
      copyToClipboard(this.context);
    },
    changeToolTipTitle() {
      changeToolTipTitle(this.context);
    },
    endtime() {
      endtime(this.context);
    },
    async getTeamsToken() {
      await getTeamToken(this.context);
    },
    async scheduled() {
      await scheduled(this.context, this);
    },
    closeScheduleCard() {
      this.openScheduleCard = false;
    },
    removeLink() {
      this.context.ScheduleInterview.meetingLink = "";
    },
    assignLink() {
      this.context.ScheduleInterview.meetingLink =
        this.context.ScheduleInterview.storeLink;
    },
    async createmeetingwithVccl() {
      await createmeetingwithVccl(this);
    },
    closeScheduleInterviewModal() {
      this.context.clearDetails = true;
      this.context.$bvModal.hide("scheduleModal");
      this.context.$bvModal.hide("schedrejectedmodal");
      this.context.ScheduleInterview.errorpanel = false;
      this.context.ScheduleInterview.externalPanelist = [];
      this.context.externalPan = [];
      this.context.ScheduleInterview.panelist = {};
      this.context.ScheduleInterview.teamsStatus = null;
      this.context.ScheduleInterview.panelistStatus = null;
      this.context.ScheduleInterview.panelist = {};
      this.context.$v.ScheduleInterview.$reset();
      this.context.ScheduleInterview = {
        date: "",
        startTime: "",
        endTime: "",
        meetingLink: "",
        meetingSummary: "",
        externalPanelist: "",
        teams: "",
        panelist: {},
      };
      this.context.disableText = false;
    },
  },
};
</script>
